import _ from 'underscore';
import parse from 'html-react-parser';

import { addQuery, cultureUrl } from './url';

export const getEmbedUrl = ({ _id, player }, autoPlay = false) => {
	const parsedPlayer = player ? parse(player.trim()) : {};

	let src = _.isEmpty(parsedPlayer)
		? `${cultureUrl}/embedded/material/${_id}`
		: parsedPlayer.props.src;

	if (autoPlay) {
		const autoplayParam = _.isEmpty(parsedPlayer)
			? { autoPlay: true }
			: { autoplay: 1 };

		src = addQuery(src, autoplayParam);
	}

	return src;
};
